import React from 'react';

export default function ListItem({ children, className, ...props }) {
  return (
    <li className={`ListItem ${className || ''}`} {...props}>
      {children}
    </li>
  );
}
